import { InputAddressData } from '@afterpaytouch/core'
import { TFunction } from 'next-i18next'
import { Country } from '@afterpay/types'
import { DateOfBirthFieldSchema } from '@afterpaytouch/form'
import { MINIMUM_AGE_RESTRICTION } from '../CreateAccount/constants'

export const getDOBValidations = (t: TFunction, address?: InputAddressData, country?: Country): Omit<DateOfBirthFieldSchema, 'type'> => {
  const maxAgeValue = 90
  const countryWithDefault = country ?? 'DEFAULT_COUNTRY'
  const countryMinimumAgeRestriction = MINIMUM_AGE_RESTRICTION[countryWithDefault]
  const minAgeValue = countryMinimumAgeRestriction[address?.state ?? ''] ?? countryMinimumAgeRestriction.DEFAULT

  return {
    minAge: {
      value: minAgeValue,
      message: t('verifyIdentity:error:minAge', { context: 'dateOfBirth', minAge: minAgeValue }),
    },
    maxAge: {
      value: maxAgeValue,
      message: t('verifyIdentity:error:maxAge', { context: 'dateOfBirth' }),
    },
  }
}
